// extracted by mini-css-extract-plugin
module.exports = {"link-parent":"link-parent___3Kheg","delivery-logos":"delivery-logos___1oE4m","logo-background":"logo-background___2LX9Y"};